import { Tab } from "@headlessui/react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const TabName = ({ tabName }) => {
  return (
    <Tab
      className={({ selected }) =>
        classNames(
          "w-full py-3 mt-3 leading-5 font-medium text-black uppercase",
          selected
            ? "bg-gray-50 border-b-2 border-indigo-500 text-indigo-500"
            : "text-black"
        )
      }
    >
      {tabName}
    </Tab>
  );
};

export default TabName;
